import ReactPlayer from 'react-player';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';
import { Button } from '@mui/material';
import WithAuth from 'src/components/auth/WithAuth';
import getAttachemntType from 'src/components/MediaGallery/getAttachmentType';
import MediaGallery from 'src/components/MediaGallery';
import MediaCarousel from 'src/components/MediaGallery/MediaCarousel';
import { useState } from 'react';

const Post = ({
  id,
  className,
  title,
  content = '',
  attachments = [],
  link,
  createdAt,
  onEditClick,
  onDeleteClick,
}) => {
  const [viewerOpen, setViewerOpen] = useState(false);
  const [index, setindex] = useState(0);

  const handleCloseViewer = () => {
    setViewerOpen(false);
  };

  const DOMPurifyConfig = {
    ADD_ATTR: ['target'],
    afterSanitizeAttributes: function (node) {
      if (node.tagName && node.tagName.toLowerCase() === 'a') {
        node.setAttribute('target', '_blank');
        node.setAttribute('rel', 'noopener noreferrer');
      }
    },
  };

  const sanitizedContent = DOMPurify.sanitize(content, DOMPurifyConfig);

  const media = attachments.map((attachment) => {
    return {
      primary: false,
      type: getAttachemntType(attachment.attachmentTypeId),
      src: attachment.attachmentUrl,
      thumbnail: attachment.thumbnail,
      attachmentUrl: attachment.attachmentUrl,
      originalFileName: attachment.originalFileName,
      caption: attachment.caption,
    };
  });

  return (
    <div className={`${className}`}>
      <div>
        {id !== 'no-posts' ? (
          <div className="text-xs font-semibold mb-2" data-cy="post-date">
            Posted on: {createdAt}
          </div>
        ) : (
          <></>
        )}
        <div className="text-3.5xl font-semibold mb-2" data-cy="post-title">
          {title}
        </div>
        <div className="mt-2 mb-4 text-lg break-words" data-cy="post-content">
          {parse(sanitizedContent)}
        </div>
        {media?.length > 0 && (
          <div className="mb-4">
            <MediaGallery
              media={media}
              onItemClick={(mediaItemIndex) => {
                setindex(mediaItemIndex);
                setViewerOpen(true);
              }}
            />
            {viewerOpen && (
              <MediaCarousel media={media} onClose={handleCloseViewer} initIndex={index} />
            )}
          </div>
        )}
        {link && (
          <ReactPlayer url={link.attachmentUrl} controls={true} width="100%" className="mb-3" />
        )}
      </div>
      {id !== 'no-posts' ? (
        <div className="flex items-center mb-12 gap-2">
          <WithAuth>
            <Button variant="outlined" data-cy="edit-button" onClick={() => onEditClick(id)}>
              Edit
            </Button>
            <Button
              variant="outlined"
              data-cy="delete-button"
              color="error"
              onClick={() => onDeleteClick(id)}
            >
              Delete
            </Button>
          </WithAuth>
        </div>
      ) : (
        <></>
      )}
      <hr />
    </div>
  );
};

export default Post;
